import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="video-demo"
export default class extends Controller {
  static targets = ["video", "videoContainer"];

  connect() {
    this.videoContainerTarget.addEventListener("close", this.pause.bind(this))
  }

  disconnect() {
    this.videoContainerTarget.removeEventListener("close", this.pause.bind(this))
  }

  open() {
    this.videoContainerTarget.showModal();
    this.videoTarget.play();
  }

  pause() {
    this.videoTarget.pause();
  }
}
